import React, { useState, useEffect } from "react";
import Navbar from "../navbar/navbar";
import Servicehead from "./../../assets/Retreat Center/Carmelretreatcenter/Carmel-divine- Elevation 02.01.2017-FINAL.webp";
import { motion } from "framer-motion";

const Hero = () => {
  const [stopScroll, setStopScroll] = useState(false);

  useEffect(() => {
    document.documentElement.style.overflowX = "hidden";
    document.body.style.overflowX = "hidden";
    document.body.style.overflowY = "hidden";
    return () => {
      document.documentElement.style.overflowX = "";
      document.body.style.overflowX = "";
      document.body.style.overflowY = "";
    };
  }, []);

  // 🎯 Ultra-Smooth Scrolling with requestAnimationFrame
  const smoothScrollTo = (targetPosition, duration = 800) => {
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animationStep(timestamp) {
      if (!startTime) startTime = timestamp;
      const timeElapsed = timestamp - startTime;
      const progress = Math.min(timeElapsed / duration, 1);

      // Ease-in-out quadratic function for smooth scrolling
      const easeInOutQuad =
        progress < 0.5
          ? 2 * progress * progress
          : -1 + (4 - 2 * progress) * progress;

      window.scrollTo(0, startPosition + distance * easeInOutQuad);

      if (timeElapsed < duration) {
        requestAnimationFrame(animationStep);
      }
    }

    requestAnimationFrame(animationStep);
  };

  // 📌 Function to scroll to the "Learn More" section
  const scrollToLearnMore = (e) => {
    e.preventDefault();
    const section = document.getElementById("learn-more-section");
    if (section) {
      const yOffset = section.getBoundingClientRect().top + window.scrollY - 50; // Adjust for navbar
      smoothScrollTo(yOffset, 1000); // 🔥 Ultra-smooth scroll with 1s duration
    } else {
      console.error("❌ #learn-more-section not found!");
    }
  };

  const heroStyles = {
    position: "relative",
    height: "100vh",
    width: "100vw",
    overflow: "hidden",
  };

  const imageStyles = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: -1,
  };

  const heroContentStyles = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "white",
    textAlign: "center",
    width: "90%",
  };

  const titleStyles = {
    fontSize: "clamp(2rem, 5vw, 3rem)",
    fontWeight: "bold",
    marginBottom: "10px",
    color: "#111827"
    
  };

  const bottomTextStyles = {
    position: "absolute",
    bottom: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    color: "#111827",
    fontSize: "24px",
    fontWeight: "bold",
    textAlign: "center",
    width: "100%",
  };

  const styles = {
    motionButton: {
      position: "relative",
      height: "50px",
      overflow: "hidden",
      padding: "12px 24px",
      marginTop: "30px",
      fontSize: "18px",
      fontWeight: "bold",
      background: "transparent",
      alignItems: "center",
      cursor: "pointer",
      border: "none",
      borderRadius: "8px",
    },
    motionButtonBackground: {
      position: "absolute",
      inset: 5,
      background: "#5c0e14",
      borderRadius: "8px",
    },
  };

  return (
    <div style={{ overflowX: "hidden", width: "100vw" }}>
      <Navbar passedScrollLimit={true} setStopScroll={setStopScroll} />

      <section style={heroStyles}>
        <img src={Servicehead} alt="Hero Background" style={imageStyles} />

        <div style={heroContentStyles}>
          <h1 style={titleStyles}>
            Our key projects that showcase our expertise 
            <h1 style={titleStyles}>and commitment</h1>
          </h1>
          <motion.button
            style={styles.motionButton}
            variants={{
              initial: { color: "grey" },
              hover: { color: "white" },
            }}
            initial="initial"
            whileHover="hover"
            onClick={scrollToLearnMore} // 🔥 Scroll to Section on Click
          >
            <motion.span
              style={styles.motionButtonBackground}
              variants={{
                initial: { x: "-100%" },
                hover: { x: 0, transition: { duration: 0.4 } },
              }}
            />
            <span style={{ position: "relative", zIndex: 1, color: "white" }}>
              Learn more
            </span>
          </motion.button>
        </div>

        <p style={bottomTextStyles}>
          Architecture | Interior Designs | Exterior Designs
        </p>
      </section>

      {/* Learn More Section - The target for scrolling */}
      <section
        id="learn-more-section"
        style={{
          padding: "50px",
          background: "#f4f4f4",
          textAlign: "center",
        }}
      >
        <h2 style={{ fontSize: "28px", color: "#333" }}>
          More About Our Projects
        </h2>
        <p
          style={{
            fontSize: "18px",
            maxWidth: "600px",
            margin: "auto",
            color: "#555",
          }}
        >
          Our projects reflect excellence in architecture, interior, and
          exterior design.
        </p>
      </section>
    </div>
  );
};

export default Hero;
